import "./home-landing-main.component.scss";

export default {
    template: require('./home-landing-main.component.html'),
    controller: function ($timeout, $q, $location, $sessionStorage, LocationsPublicApi,
                          ServicesPublicApi, Notification, ErrorHandler, $t, vuiLocation) {
        'ngInject';

        const PLAYED_VIDEO_KEY = 'video-was-played';

        const self = this;
        this.showContent = $sessionStorage.get(PLAYED_VIDEO_KEY);
        this.selectedService = null;
        this.selectedAddress = null;
        this.addressFilter = '';
        this.services = [];

        this.startAnimation = () => {
            this.showContent = true;
            $sessionStorage.tryToSet(PLAYED_VIDEO_KEY, true);
        }

        this.play = (e) => {
            e.target.play();
        }

        this.searchAddress = function (request) {
            const deferred = $q.defer();
            const query = {
                address: request
            };
            query.types = 'geocode';

            LocationsPublicApi.autocomplete(query, function (data) {
                data.unshift({addressType: 'DETECT_CURRENT_LOCATION'});
                deferred.resolve(data);
            }, function (error) {
                deferred.reject(error);
            });

            return deferred.promise;
        };

        this.displayItem = (item) => {
            if (item && item.addressType && 'DETECT_CURRENT_LOCATION' === item.addressType) {
                return " ";
            }
            if (item && !item.address) {
                return item;
            }
            if (item && item.address) {
                return item.address;
            }
            if (this.selectedAddress && this.selectedAddress.address) {
                return this.selectedAddress.address;
            }

            return null;
        }

        this.quickBooking = function () {
            if (this.selectedAddress && this.selectedAddress.address && this.selectedService) {
                $location.path('/quick-booking').search({
                    location: this.selectedAddress ? vuiLocation.serializeAddress(this.selectedAddress) : undefined,
                    selectedService: this.selectedService ? self.selectedService.code : undefined
                });
            } else {
                Notification.warning($t('public.landing.home.main_address_service_required_error_message'));
            }
        }

        this.onItemChange = (selectedAddress) => {
            if (selectedAddress && 'DETECT_CURRENT_LOCATION' === selectedAddress.addressType) {
                detectCurrentLocation();
            } else if (self.selectedAddress && !self.selectedAddress.bounds) {
                LocationsPublicApi.details({id: selectedAddress.placeId}, function (l) {
                    l.address = selectedAddress.address;
                    self.selectedAddress = l;
                });
            }
        };

        const detectCurrentLocation = () => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((position) => {
                    const request = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };

                    try {
                        LocationsPublicApi.geocode(request, {}, (l) => {
                            self.selectedAddress = l;
                        }, (error) => {
                            ErrorHandler.onError(error, $t('shared.location_autocomplete.detect_current_location_error'));
                        });
                    } finally {
                        self.selectedAddress = null;
                    }
                }, (error) => {
                    self.selectedAddress = null;
                    Notification.warning($t('shared.location_autocomplete.geolocation_not_supported_error'));
                });
            } else {
                self.selectedAddress = null;
                Notification.warning($t('shared.location_autocomplete.geolocation_not_supported_error'));
            }
        };

        ServicesPublicApi.query(function (response) {
            response.forEach(service => {
                service.toString = () => {
                    return service.name;
                }
                self.services.push(service);
            });
        }, function (error) {
            ErrorHandler.onError(error);
        });
    }
};
